import React from "react";
import { VideoIcon } from "lucide-react";
import { modules } from "../data/content";
export function Program() {
  return <section id="programa" className="bg-ink-2 px-6 py-20 sm:py-28" data-id="element-92" data-mp="f0jmo8dkl91h">
      <div className="mx-auto max-w-5xl" data-id="element-93" data-mp="a1p497jilmhw">
        <div className="mb-12 text-center sm:mb-16" data-id="element-94" data-mp="a2i2fk4er3of">
          <p className="mb-4 text-sm font-semibold text-gold" data-id="element-95" data-mp="53nj8h2j3d3s">Radar Digital</p>
          <h2 className="mb-3 font-serif text-[clamp(30px,4.5vw,46px)] font-bold leading-tight" data-id="element-96" data-mp="12qvyvvfulrxv">
            Lo que vas a aprender
          </h2>
          <p className="text-[15px] text-muted" data-id="element-97" data-mp="xt4avcibqpyy">8 módulos completos para crear y vender tu primer ebook desde cero</p>
        </div>

        <ol className="grid border-t border-line md:grid-cols-2 md:gap-x-12" data-id="element-98" data-mp="suszuygam9f5">
          {modules.map((m, i) => <li key={m.title} className="flex items-start gap-5 border-b border-line py-6" data-id="element-99" data-mp="3diyw3e7vb82w" data-mpi={i}>
              <span className="w-8 shrink-0 font-serif text-2xl font-bold leading-none text-gold" data-id="element-100" data-mp="3dgm8akffi3hx">{i + 1}</span>
              <div data-id="element-101" data-mp="1omoisxy4ollv">
                <h3 className="mb-1 font-sans text-[15px] font-semibold text-white" data-id="element-102" data-mp="1om5beb63tfm3">{m.title}</h3>
                <p className="text-sm leading-relaxed text-muted" data-id="element-103" data-mp="1tlrpsnxo51wh">{m.description}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 flex flex-col gap-4 rounded-xl border border-gold/25 bg-gold/[0.06] p-6 sm:flex-row sm:items-center sm:gap-5 sm:p-7" data-id="element-104" data-mp="1flgzbm09tpbu">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gold text-black" data-id="element-105" data-mp="15vf84lcmfqsp">
            <VideoIcon className="h-6 w-6" aria-hidden="true" data-id="element-106" data-mp="1anp6mprsxz6l" />
          </span>
          <div data-id="element-107" data-mp="vy9ilhjno7ul">
            <p className="font-serif text-lg font-bold text-gold" data-id="element-108" data-mp="vyj00gqmx6oo">Asesoría semanal en vivo con Marcos</p>
            <p className="text-sm leading-relaxed text-soft" data-id="element-109" data-mp="10xvthkc0hc08">
              Cada semana te reviso el negocio, respondo tus dudas y te digo exactamente qué hacer para avanzar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}